// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import star01Icon from "@/assets/icons/star-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Star01IconProps = Omit<IconProps, "name">;

export function Star01Icon(props: Star01IconProps): React.ReactNode {
  return <Icon name={star01Icon} {...props} />;
}
